import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomAttributeNamesDataState from "@tCentro/Store/Data/CustomAttributeNamesDataState";
import { Draft } from "immer";

const initialState: CustomAttributeNamesDataState = {
    attributeNameValues: [],
    mainData: [],
};

const reducer = {
    "Custom/ProductListCardList/AttributeNames": (draft: Draft<CustomAttributeNamesDataState>, action: { data: any }) => {
        draft.attributeNameValues = action.data;
    },
    "Custom/ProductListCardList/AttributeFilteredData": (draft: Draft<CustomAttributeNamesDataState>, action: { data: any }) => {
        draft.mainData = action.data;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
